import { notImplemented, mod97CheckSum } from "../utils/general-helper";
import { IRegionFunctions, ParsedAccount } from "./region-functions";

const regionFunctionsFI: () => IRegionFunctions = () => {
	//Finnish accountnumbers follow IBAN structure
	const validaPhoneNrExpression = RegExp(/^(\+358|0)\d{1,3}[- ]?\d{3}[- ]?\d{4}$/);
	const basicIbanStructureRegEx = RegExp(/^(?=.{15,34}$)[A-Z]{2}[A-Z0-9]+$/);
	//as we dont have any validation for this country we sett max length do DB max length
	const accountNumberMaxLength = 50;

	const validPhoneNumber = (phoneNumber: string): boolean => validaPhoneNrExpression.test(phoneNumber);

	const formatPhoneNumber = (_phoneNumber: string): string => {
		return notImplemented();
	};

	const validateAccountNumber = (accountNumber: string): boolean => {
		if (accountNumber.length < 1) return true;
		return accountNumber.length > 0 && accountNumber.length <= accountNumberMaxLength;
	};

	const getBankAccountMeta = (_accountNrIncludingClearing?: string) => {
		return {
			clearingNumberLength: 0,
			accountNumberMaxLength,
		};
	};

	const parseAccountNumber = (accountNrIncClearing: string): ParsedAccount => {
		return { clearingNumber: "", accountNumber: accountNrIncClearing };
	};

	const formatAccountNumber = (clearingNr: string, accountNr: string) => {
		return clearingNr + accountNr;
	};

	const validateIban = (IBAN: string, allowedCountryCodes?: string): boolean => {
		if (IBAN.length < 1) return true;
		if (allowedCountryCodes && allowedCountryCodes !== "") {
			const ibanCountryCode = IBAN.substring(0, 2);
			if (!allowedCountryCodes.split(",").some((countryCode) => countryCode === ibanCountryCode))
				return false;
		}
		IBAN = IBAN.replace(/[\s]+/g, "").toUpperCase();
		if (!basicIbanStructureRegEx.test(IBAN)) return false;

		const rearrangedIban = IBAN.slice(4) + IBAN.slice(0, 4);
		const convertedIban = rearrangedIban.replace(/[A-Z]/g, (char) => (char.charCodeAt(0) - 55).toString());

		return mod97CheckSum(convertedIban);
	};

	return {
		validateAccountNumber,
		validPhoneNumber,
		validateIban,
		formatAccountNumber,
		formatPhoneNumber,
		parseAccountNumber,
		bankAccountMeta: getBankAccountMeta,
	};
};

export const FIRegionFunctions = regionFunctionsFI();
